import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import VueMoment from 'vue-moment';
import VueD3 from 'vue2-d3';
import { VueMasonryPlugin } from 'vue-masonry';
import VueResource from 'vue-resource';
import VueCryptojs from 'vue-cryptojs';
import TheMask from 'vue-the-mask';
import Buefy from 'buefy';
import VueLazyLoad from 'vue-lazyload';
// https://github.com/AurityLab/vue-recaptcha-v3/tree/vue-v2.x
import { VueReCaptcha } from 'vue-recaptcha-v3';
// Input international
import VueTelInput from 'vue-tel-input';
import money from 'v-money';

// https://github.com/KABBOUCHI/vue-tippy - Tooltip
import VueTippy, { TippyComponent } from 'vue-tippy';
import VueApexCharts from 'vue-apexcharts'

export const setUse = (Vue) => {
    Vue.use(VueMoment, { moment });
    Vue.use(VueResource);
    Vue.use(VueD3);
    Vue.use(VueMasonryPlugin);
    Vue.use(VueCryptojs);
    Vue.use(TheMask);
    Vue.use(Buefy);
    Vue.use(VueLazyLoad);
    Vue.use(VueTelInput, {
        dropdownOptions: { showDialCodeInSelection: true },
    });
    Vue.use(money);
    Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPCHA });
    Vue.use(VueTippy, {
        arrow: true,
        arrowType: 'round',
        theme: 'google',
        followCursor: true,
    });
    Vue.component('vueTippy', TippyComponent);
    Vue.use(VueApexCharts);
    Vue.component('apexchart', VueApexCharts);
};
